<template>
  <a
    v-if="url"
    :href="url"
    class="sheet-link"
    target="_blank"
    rel="noopener"
  >
    PDF
  </a>
</template>

<script>
export default {
  name: 'PdfLink',
  props: {
    url: {
      type: String,
      required: false
    }
  }
}
</script>

<style scoped>
.sheet-link {
  color: #66b2ff;
  margin-left: 1rem;
  font-size: 0.9rem;
}
</style>
